import * as React from "react";
import { useParams } from "react-router-dom";

import { Loading } from "../../../../../../../react-components/lu-component/src/index";
import { adCopyV3Endpoint } from "../../../../../../../server/router/ad-copy/endpoint";
import { AdCopyRetestMenu } from "../../../../../components/pages/ad-copy/report/common";
import { ConfirmBox } from "../../../../../components/parts/confirm-box";
import { get, makeError } from "../../../../../lib/request";
import { initState, reducer } from "../../../../../reducers/ad-copy/report/latest/key-mearurements";
import { GetKeyMeasurementsResponse } from "../../../../../../../server/types/request/report/key-mesurements";
import { KeyMeasurementsReportPage } from "../../../../../components/pages/report/key-measurements";

export const AdCopyKeyMeasurementsReportContainer = () => {
	const [state, dispatch] = React.useReducer(reducer, initState);

	const { data, info, job, loading } = state;

	const { activityId, jobId } = useParams<{
		activityId: string;
		jobId: string;
	}>();

	React.useEffect(() => {
		get<GetKeyMeasurementsResponse>(`${adCopyV3Endpoint.keyMeasurementsReport}/${jobId}`)
			.then((response) => {
				dispatch({ payload: response.data, type: "loadData" });
			})
			.catch((error) => {
				dispatch({ payload: makeError(error), type: "changeMessageInfo" });
			});
	}, [jobId]);

	return (
		<>
			<Loading loading={loading} />

			{job && job.retestJobId && (
				<AdCopyRetestMenu activityId={activityId ?? ""} jobId={job.retestJobId.toString()} page="key-mesurements" />
			)}

			<ConfirmBox info={info} />

			<KeyMeasurementsReportPage data={data} job={job} topRowMinWidth={230} />
		</>
	);
};
